export default "__VITE_ASSET__d21e2c22__"